// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IrHg","col":"styles_col__lbx-D"};